(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatch-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSwatchTabs(root) {
      if (root.dataset.swatchTabsBound === 'true') return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.swatch-tab'));
      if (!tabs.length) return;
      root.dataset.swatchTabsBound = 'true';

      var panels = Array.prototype.slice.call(root.querySelectorAll('.swatch-panel'));

      function activate(name) {
        tabs.forEach(function (t) {
          var on = t.dataset.tab === name;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.panel === name);
        });
      }

      // A link can open a specific tab via the configured query param, e.g.
      // /products/x?tab=sets. Falls back to the server-rendered default.
      var param = root.dataset.tabParam || 'tab';
      var requested = null;
      try {
        requested = new URLSearchParams(window.location.search).get(param);
      } catch (e) {}
      if (requested && tabs.some(function (t) { return t.dataset.tab === requested; })) {
        activate(requested);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.dataset.tab); });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-swatch-selector][data-tabbed="true"]').forEach(initSwatchTabs);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    // Re-bind when the block is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
